import React from 'react';
import { Container } from 'react-bootstrap';
import CopyrightNotice from '../CopyrightNotice';

interface Props {
  children: React.ReactNode;
  className?: string;
}

const FixedFooter: React.FC<Props> = ({ children, className }) => {
  return (
    <div className={`fixed-footer${className ? ` ${className}` : ''}`}>
      <Container>
        {children}
        <CopyrightNotice isInFixedFooter />
      </Container>
    </div>
  );
};

export default FixedFooter;
